import { render, staticRenderFns } from "./Threads.vue?vue&type=template&id=ab07e65a&scoped=true&lang=pug"
import script from "./Threads.vue?vue&type=script&lang=js"
export * from "./Threads.vue?vue&type=script&lang=js"
import style0 from "./Threads.vue?vue&type=style&index=0&id=ab07e65a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab07e65a",
  null
  
)

export default component.exports